import { render, staticRenderFns } from "./PartnersMRRDiagram.vue?vue&type=template&id=7c87fa23&"
import script from "./PartnersMRRDiagram.vue?vue&type=script&lang=js&"
export * from "./PartnersMRRDiagram.vue?vue&type=script&lang=js&"
import style0 from "./PartnersMRRDiagram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VToolbar})
